import { CatalogueGateway } from './catalogue-gateway.interface';

const baseUrl = 'gk/catalogue';
export class HttpCatalogueGateway implements CatalogueGateway {
  public baseUrl = baseUrl;

  getCatalogue(args: { groupName: string }) {
    return {
      url: baseUrl,
      method: 'GET',
      params: { groupName: args?.groupName },
    };
  }

  getAllModels() {
    return { url: `${baseUrl}/models`, method: 'GET' };
  }

  getModelbyId(args: { modelId: string }) {
    return { url: `${baseUrl}/models/${args.modelId}`, method: 'GET' };
  }

  getAllKits() {
    return { url: `${baseUrl}/kits`, method: 'GET' };
  }

  getKitById(args: { kitId: string }) {
    return { url: `${baseUrl}/kits/${args.kitId}`, method: 'GET' };
  }

  getAllStudios() {
    return { url: `${baseUrl}/studios`, method: 'GET' };
  }

  getStudioById(args: { studioId: string }) {
    return { url: `${baseUrl}/studios/${args.studioId}`, method: 'GET' };
  }

  getAllEquipments() {
    return { url: `${baseUrl}/equipments`, method: 'GET' };
  }

  getEquipmentById(args: { equipmentId: string }) {
    return {
      url: `${baseUrl}/equipments/${args.equipmentId}`,
      method: 'GET',
    };
  }

  getAllFinishes() {
    return { url: `${baseUrl}/finishes`, method: 'GET' };
  }

  getFinishById(args: { finishId: string }) {
    return { url: `${baseUrl}/finishes/${args.finishId}`, method: 'GET' };
  }

  getAllOptions() {
    return { url: `${baseUrl}/options`, method: 'GET' };
  }

  getOptionById(args: { optionId: string }) {
    return { url: `${baseUrl}/options/${args.optionId}`, method: 'GET' };
  }

  syncOptions() {
    return { url: `${baseUrl}/sync-options`, method: 'POST' };
  }

  syncModelFinishEquipment() {
    return {
      url: `${baseUrl}/sync-models-finishes-equipments`,
      method: 'POST',
    };
  }

  syncStudios() {
    return { url: `${baseUrl}/sync-studios`, method: 'POST' };
  }

  getBimCatalogue() {
    return { url: `${baseUrl}/bim`, method: 'GET' };
  }

  getBimNodeCatalogue(args: { nodeId: string }) {
    return { url: `${baseUrl}/bim/${args.nodeId}`, method: 'GET' };
  }

  addElementToBimCatalogue(args: { parentId: string; data: any }) {
    return {
      url: `${baseUrl}/bim/${args.parentId}`,
      method: 'POST',
      data: args.data,
    };
  }

  postFileToBimCatalogue(args: { nodeId: string; data: any }) {
    return {
      url: `${baseUrl}/bim/${args.nodeId}/file`,
      method: 'POST',
      data: args.data,
      headers: { 'content-type': 'multipart/form-data' },
    };
  }

  getAllDefaultOptionFinishEquipment() {
    return {
      url: `${baseUrl}/default-option-finish-equipment`,
      method: 'GET',
    };
  }

  postDefaultOptionFinishEquipment(args: { data: any }) {
    return {
      url: `${baseUrl}/options/default-option-finish-equipment`,
      method: 'POST',
      data: args.data,
    };
  }

  patchDefaultOptionFinishEquipment(args: { id: string; data: any }) {
    return {
      url: `${baseUrl}/options/${args.id}/default-option-finish-equipment`,
      method: 'PATCH',
      data: args.data,
    };
  }

  deleteDefaultOptionFinishEquipment(args: { id: string }) {
    return {
      url: `${baseUrl}/options/${args.id}/default-option-finish-equipment`,
      method: 'DELETE',
    };
  }

  postDefaultOptionModel(args: { modelId: string; data: string }) {
    return {
      url: `${baseUrl}/models/${args.modelId}/default-option`,
      method: 'POST',
      data: { defaultOptionModel: args.data },
    };
  }

  patchDefaultOptionModel(args: {
    defaultOptionModelId: string;
    data: string;
  }) {
    return {
      url: `${baseUrl}/models/${args.defaultOptionModelId}/default-option`,
      method: 'PATCH',
      data: { defaultOptionModel: args.data },
    };
  }

  deleteDefaultOptionModel(args: { modelId: string; optionId: string }) {
    return {
      url: `${baseUrl}/models/${args.modelId}/default-option/${args.optionId}`,
      method: 'DELETE',
    };
  }
}
